import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const firstHalf = categories.slice(0, 7);
  const secondHalf = categories.slice(7);

  return (
    <footer className="bg-background-100 rounded-t-3xl mt-16">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <a
              href="/"
              className="inline-block mb-4 cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                navigate('/');
              }}
            >
              <span className="text-2xl font-heading font-bold text-foreground-900 tracking-tight">
                Kakobuy<span className="text-primary-500">Finds</span>
              </span>
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-sm">
              {t('footer.description')}
            </p>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
              {t('footer.categories')}
            </h4>
            <ul className="space-y-2.5">
              {firstHalf.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150 cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
              &nbsp;
            </h4>
            <ul className="space-y-2.5">
              {secondHalf.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150 cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
              Poradniki SEO
            </h4>
            <ul className="space-y-2.5">
              <li>
                <button
                  onClick={() => navigate('/artykul/kakobuy-sheet-kompletny-przewodnik')}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150 cursor-pointer text-left"
                >
                  Pełny Przewodnik
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/artykul/porownanie-spreadsheet-zakupowych')}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150 cursor-pointer text-left"
                >
                  Porównanie Platform
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/artykul/bezpieczne-korzystanie-ze-spreadsheet')}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150 cursor-pointer text-left"
                >
                  Bezpieczeństwo
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/artykul/kakobuy-spreadsheet-sneakersy-buty')}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150 cursor-pointer text-left"
                >
                  Sneakersy i Buty
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/artykul/kakobuy-spreadsheet-moda-odziez')}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150 cursor-pointer text-left"
                >
                  Moda i Odzież
                </button>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
              {t('footer.guides')}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="/"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150 cursor-pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/');
                  }}
                >
                  Strona główna
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            {t('footer.copyright')}
          </p>
          <div className="flex items-center gap-6">
            <a
              href="/"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-150 cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                navigate('/');
              }}
            >
              {t('footer.privacy')}
            </a>
            <span className="text-foreground-300">|</span>
            <a
              href="/"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-150 cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                navigate('/');
              }}
            >
              {t('footer.terms')}
            </a>
            <span className="text-foreground-300">|</span>
            <a
              href="/"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-150 cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                navigate('/');
              }}
            >
              {t('footer.disclaimer')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}